import React from "react";

const GoldenArrow = React.memo(() => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" version="1.1" viewBox="0 0 34 55">
            <image width="34" height="55" href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAA3CAMAAABegmjYAAAAAXNSR0IB2cksfwAAAIFQTFRFAAAA6qoq5J8l5KIl5KIk5qIl5KIk5KIj6KIn358g46Ik5aIk5KIj558o46Il5aMl5KIk5KIk5aMj46Eh5KIk46Ik5KIj5KEj46Mj5KIk5KMl45wr5KIk5KIk5KIk5KIk5KIl5KIk5aIk5KMj25Ik5KIk5aMl/79A5KIk//8A46Ik1M62DgAAACt0Uk5TAAwww+0p/+YhCN633yA3RfjzOi76nZeQSP1LEs2zqqKZ/mteB7quBKEBP1LiAUAAAACPSURBVHic7co5FoJAEADRHtDWEcV9V9wRvf8BHU1IfFMoBARUWl/knQkEMmGrTUK10/UJ64Rqz2NspJ/6AxIeE6uiGY5qZsZsJo2p1EzZzOZstIhZFDDLEma1zs3mq9jucrFHkVQgDiiOJE5nFJc/hWERNuI3YVlE5YVcbyScSUmI3FMSzmQkRB4ZCdfT817iBRn8RNqhxQAAAABJRU5ErkJggg=="/>
        </svg>
    );
});

export default GoldenArrow;
